const lbaReasonForTravelSelect = angular.module('app.lbaReasonForTravelSelect', []);

lbaReasonForTravelSelect.controller('lbaReasonForTravelSelectCtrl', require('./lbaReasonForTravelSelectCtrl'));
lbaReasonForTravelSelect.directive('lbaReasonForTravelSelect', require('./lbaReasonForTravelSelectDir'));

export default lbaReasonForTravelSelect;



// WEBPACK FOOTER //
// ./src/components/lbaReasonForTravelSelect/index.js